// The corresponding enum in the backend is called "TariffName" but to the outside we only have the notion of a product
// Product (Frontend) = Tariff + Product (Backend)
export enum Product {
  TERM_LIFE_INSURANCE_CONSTANT = "termLifeInsuranceConstant",
  PILLAR_3A_CONSTANT = "pillar3aConstant",
}
